import { categoriasSelector } from "features/Inventario/redux/selectors/categoriasSelectors"
import {
  clearCatalogosState,
  getArticulosByCategoria,
  getArticulosSelected,
  getCategoriasTree,
  selectCategoriasTree,
  setCategoriasTree,
  unSelectCategoriasTree,
} from "features/Inventario/redux/slices/catalogosSlice"
import { getAllCategorias } from "features/Inventario/redux/slices/categoriasSlice"
import { useEffect } from "react"

import * as ROUTES from "routes/RoutePaths"

import notification from "common/utils/notification"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import i18next from "i18next"
import { useHistory } from "react-router-dom"
import {
  catalogosSelector,
  categoriasTreeSelector,
  isReadyToCreateOrUpdateCatalogo,
  manyArticulosSelectedSelector,
} from "../redux/selectors/catalogosSelector"

const useCatalogos = ({ catalogoId }: $TSMigrationFixMe) => {
  const manyArticulosSelected = useSelector(manyArticulosSelectedSelector)
  const {
    creatingCatalogo,
    updatingCatalogo,
    catalogoSuccessCreated,
    fetchingCatalogosTree,
    articulosSelected,
    catalogoSuccessUpdated,
  } = useSelector(catalogosSelector)

  const isReadyToCreateOrUpdate = useSelector(isReadyToCreateOrUpdateCatalogo)

  const { fetchingCategorias } = useSelector(categoriasSelector)

  const categoriasTree = useSelector(categoriasTreeSelector)

  const dispatch = useDispatch()
  const history = useHistory()

  // @ts-expect-error TS(2322): Type ...
  useEffect(() => () => dispatch(clearCatalogosState()), [dispatch])

  useEffect(() => {
    dispatch(getAllCategorias())
    dispatch(getCategoriasTree())
  }, [dispatch])

  useEffect(() => {
    if (catalogoId) {
      dispatch(getArticulosSelected(catalogoId))
    } else {
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      dispatch(getArticulosByCategoria())
    }
  }, [dispatch, catalogoId])

  useEffect(() => {
    if (catalogoSuccessCreated) {
      notification.success({
        body: `${i18next.t("notification.catalogCorrectCreated")}`,
      })
      history.push(ROUTES.CATALOGOS)
    }
  }, [history, catalogoSuccessCreated])

  useEffect(() => {
    if (catalogoSuccessUpdated) {
      notification.success({
        body: `${i18next.t("notification.catalogCorrectEdit")}`,
      })
      history.push(ROUTES.CATALOGOS)
    }
  }, [history, catalogoSuccessUpdated])

  const handleSetCategoriasTree = (categorias: $TSMigrationFixMe) => {
    dispatch(setCategoriasTree(categorias))
  }

  const handleSelectCategoria = ({ node }: $TSMigrationFixMe) => {
    dispatch(selectCategoriasTree(node))
  }

  const handleUnSelectCategorias = ({ node }: $TSMigrationFixMe) => {
    dispatch(unSelectCategoriasTree(node))
  }

  const clearState = () => {
    dispatch(clearCatalogosState())
  }

  return {
    categoriasTree,
    creatingCatalogo,
    updatingCatalogo,
    fetchingCategorias,
    manyArticulosSelected,
    fetchingCatalogosTree,
    articulosSelected,
    isReadyToCreateOrUpdate,
    handleSetCategoriasTree,
    handleSelectCategoria,
    handleUnSelectCategorias,
    clearState,
  }
}

export default useCatalogos
